import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutAuth} from "./layouts/auth/auth.component";
import {LayoutDefaultComponent} from "./layouts/default/default.component";
import {CustomPreloadingStrategyService} from "./services/custom-preloading.service";
import {LayoutErrorComponent} from "./layouts/error/error.component";
import {environment} from "../environments/environment";
import {AuthGuard} from "./guards/auth.guard";

const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        component: LayoutAuth,
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
        data: {preload: false}
    },
    {
        path: '',
        component: LayoutDefaultComponent,
        title: 'common.name',
        loadChildren: () => import('./modules/analytics/analytics.module').then(m => m.AnalyticsModule),
        data: {preload: true}
    },
    {
        path: environment.administratorPrefix,
        component: LayoutDefaultComponent,
        title: 'modules.admin.common.name',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        data: {preload: false},
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard]
    },
    {
        path: 'error',
        component: LayoutErrorComponent,
        title: 'modules.error.common.title',
        loadChildren: () => import('./modules/error/error.module').then(m => m.ErrorModule),
        data: {preload: false}
    },
    /**
     * Page 404
     */
    {path: '**', redirectTo: 'error/404.html'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        preloadingStrategy: CustomPreloadingStrategyService,
        //@ts-ignore
        relativeLinkResolution: 'legacy'
    })],
    exports: [
        RouterModule
    ],
    providers: [
        CustomPreloadingStrategyService
    ]
})
export class AppRoutingModule {
}
